export default __webpack_public_path__ + "img/6.c0928dfd.jpg";